export function isMobileViewport(): boolean {
  return window.matchMedia('(max-width: 768px)').matches;
}
